(function ($) {
  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   */

  const initializeBlock = function () {
    $(".news-swiper").each(function () {
      let newsSwiper;
      const el = $(this)[0];
      const options = {
        loop: false,
        autoHeight: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        breakpoints: {
          // when window width is >= 480px
          480: {
            slidesPerView: 3.2,
            spaceBetween: 0,
          },
        },
        watchOverflow: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      };

      newsSwiper = new Swiper(el, options);
    });
  };

  // Initialize each block on page load (front end).
  $(function () {
    initializeBlock($(this));
  });

  // // Initialize dynamic block preview (editor).
  // if( window.acf ) {
  //     window.acf.addAction('render_block_preview/type=program', initializeBlock)
  // }
})(jQuery);
